const sfs_5050 = {
  init: () => {


    if ($('.shopify-section .sfs-5050')[0]) {

        $('.shopify-section .sfs-5050').each(function() {
            let section_id = $(this).data('section-id');
            let parent = `.sfs-5050[data-section-id="${section_id}"]`;

            function randomRotate($photoEl)
            {
                let randMin = -10.00,
                    randMax = 10.00,
                    degrees = (Math.random() * (randMax - randMin) + randMin).toFixed(4),
                    dist    = degrees * 2;
                $photoEl.css('transform', `rotate(${degrees}deg) translateY(${dist}px) translateX(${dist}px) scale(0.9)`);
            }

            $(`${parent} .sfs-5050__images.stack .photo-stack__photo`).each(function() {
                randomRotate($(this));
            });

            $(`${parent} .sfs-5050__images.stack .photo-stack__photo`).on('click', function() {
                $(this).css({
                    'opacity': 0,
                    'transform': 'translateY(50px) scale(0.9)'
                });
                setTimeout(() => {
                    $(this).insertBefore($('.photo-stack__photo')[0]);
                }, 250);
                setTimeout(() => {
                    $(this).css('opacity', 1);
                    randomRotate($(this));
                }, 1000);
            });

        });
            
    }


  }
};
export default sfs_5050;